export const COMPANYTAXDATALIST_PAGE = 'COMPANYTAXDATALIST_PAGE';
export const COMPANYTAXDATALIST_STARTDATE = 'COMPANYTAXDATALIST_STARTDATE';
export const COMPANYTAXDATALIST_ENDDATE = 'COMPANYTAXDATALIST_ENDDATE';
export const COMPANYTAXDATALIST_DEPARTURECOUNTRYID = 'COMPANYTAXDATALIST_DEPARTURECOUNTRYID';
export const COMPANYTAXDATALIST_ARRIVALCOUNTRYID = 'COMPANYTAXDATALIST_ARRIVALCOUNTRYID';
export const COMPANYTAXDATALIST_VATCOUNTRYID = 'COMPANYTAXDATALIST_VATCOUNTRYID';
export const COMPANYTAXDATALIST_BUYERTYPE = 'COMPANYTAXDATALIST_BUYERTYPE';
export const COMPANYTAXDATALIST_TRANSACTIONTYPE = 'COMPANYTAXDATALIST_TRANSACTIONTYPE';
export const COMPANYTAXDATALLIST_DELIVERYCONDITION = 'COMPANYTRANSACTIONLIST_DELIVERYCONDITION';
export const COMPANYTAXDATALLIST_VATISVALID = 'COMPANYTAXDATALLIST_VATISVALID';